import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, BehaviorSubject, Subject } from 'rxjs';

import { Open } from '../core/models/open.model';
import { Real } from '../core/models/real.model';
import { Employee } from '../core/models/employee.model';
import { ShopDetailService } from "../core/services/shop-detail.service";

import { Location } from "@angular/common";
import { SearchPreferencesService } from '../core/services/search-preferences.service';
import { UrlService } from '../core/services/url.service';

import { map, tap, concatMap, concat, first, distinctUntilChanged, skip   } from 'rxjs/operators';

import { ModalController } from '@ionic/angular';
import { EmployeeModalComponent } from './employee-modal/employee-modal.component';

import { NgMeta } from 'ngmeta';
import * as moment from 'moment';

import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-shop-detail',
  templateUrl: './shop-detail.page.html',
  styleUrls: ['./shop-detail.page.scss'],
})
export class ShopDetailPage implements OnInit {

  real$: Observable<Real>

  open$: Observable<Open>

  private anchor:Subject<string> = new Subject<string>();
  anchor$ = this.anchor.asObservable();

  employees$: Observable<Employee[]>;

  searchPreferencesSubscription: Subscription;
  
  anchorSubscription: Subscription;
  
  currentRoute: string;

  clean = false;
  menuPickClean = false;

  slidesOptions4 = {

    slidesPerView: 1.1, 
    initialSlide: 0, 
    speed: 400,
    spaceBetween: 2, 
    breakpoints: {
      700: {
        slidesPerView:2.1,
        spaceBetween: 2 
      },
      1100: {
        slidesPerView:3.1,
        spaceBetween: 2 
      },
      1500: {
        slidesPerView:4,
        spaceBetween: 2 
      }
    }

  };

  slidesOptions3 = {

    slidesPerView: 1.1, 
    initialSlide: 0, 
    speed: 400,
    spaceBetween: 2, 
    breakpoints: {
      700: {
        slidesPerView:2.1,
        spaceBetween: 2 
      },
      1100: {
        slidesPerView:3,
        spaceBetween: 2 
      }
    }

  };

  slidesOptions2 = {

    slidesPerView: 1.1, 
    initialSlide: 0, 
    speed: 400,
    spaceBetween: 2, 
    breakpoints: {
      700: {
        slidesPerView:2,
        spaceBetween: 2 
      }
    }

  };

  slidesOptions1 = {
    slidesPerView: 1
  };




  constructor( 
    private shopDetailService: ShopDetailService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private searchPreferencesService: SearchPreferencesService,
    private urlService: UrlService, 
    private modalCtrl: ModalController,
    private ngMeta: NgMeta,
    private translateService: TranslateService,
  ) {

    /*this.searchPreferencesService.searchPreferences$.pipe(
      first()
    )*/

    
  }

  scrollToAnchor( anchor ) {
    this.anchor.next( anchor );
  }


 /* getPictures( avatar, gallery, galleryFirst ) {

    let pictures: string[] = [];

    if ( !gallery ) {

      if ( avatar && avatar.document ) {
        pictures.push( avatar.document );
      } 

    }

    if ( galleryFirst ) {
      pictures.push( avatar.document);
    }



  }*/

  back() {

    console.log('previousUrl', this.urlService.previousUrlSnapshot );

    //if previous url is landing, redirect to landing, otherwise got to listing
    if ( '/' === this.urlService.previousUrlSnapshot || !this.urlService.previousUrlSnapshot ) {
      this.router.navigate(['/']);
    } else {
      this.searchPreferencesService.navigateToShopListing();
    }

  }

  ngOnDestroy() {
  }

  ngOnInit() {

    if ( this.route.snapshot.params.shopSlug === 'restavracija-strelec' || this.route.snapshot.params.shopSlug === 'jaz-by-me' ) {
      this.clean = true;
    }

    //set premium theme for strelec and similar
    /*let premiumThemeArr = [ 
     'restavracija-strelec'
    ];

    console.log(this.route.snapshot);

    if ( this.route.snapshot.params.shopSlug && premiumThemeArr.includes( this.route.snapshot.params.shopSlug ) ) {
     console.log(this.route.snapshot.params.shopSlug);
     document.body.classList.add('premium');

    } else {

     console.log('not premium');
      
      document.body.classList.remove('premium');
    }*/

    this.currentRoute = this.route.snapshot.routeConfig.path;
    
    //this.anchorSubscription = this.anchor$.subscribe( anchor => this.scrollTo( anchor ) );
    
    this.real$ = this.shopDetailService.getReal( this.route.paramMap ).pipe(
      tap( real => {

        this.ngMeta.setAll({
          title: real.getMetaTitleName() + ' | Rezervacija miz ',
          description:
            'Izberi termin in se naroči prek spleta!',
        });
        
        this.open$ = this.shopDetailService.getOpen( real.provider.id, real.id );
        this.open$.subscribe(open => {
          console.log(open);      
        });

      })      
    );


  }

  goBack(){
    this.location.back();
  }  


}
